<nav aria-label="breadcrumbs" class="bolt-space-bottom-2xl">
    <is-bread-crumbs
        class="breadCrumbs"
        [homeIconLink]="homeIconLink"
        [breadCrumbs]="breadCrumbs"
        [currentPage]="currentPage"
        position="top"
        [isClaims]="true">
    </is-bread-crumbs>
</nav>
<main>
    <div class="bolt-container">
         @if (showError) {
                <bolt-notification type="error" class="bolt-space-bottom-lg">
                    Please select a repair shop before continuing.
                </bolt-notification>
            }
        <div class="bolt-row">
            <find-repair-shop
                id="findRepairShopOYS"
                [clientId]="clientId"
                [userType]="sessionService.getUserType()"
                [accessToken]="accessToken"
                [defaultSearchLocation]="vehicleLocation"
                [claimId]="claimId"
                [externalClaimId]="externalClaimId"
                [vehicleIncidentId]="vehicleIncidentId"
                [env]="env"
                (data)="shopDetails($event)"
                (analytics)="handleAnalytics($event)"
                (onError)="handleError('Find repair shop OYS', $event)">
            </find-repair-shop>
        </div>
    </div>
    <!-- Button bar hidden until page loads -->
    @if (!isLoading) {
        <bolt-button-bar layout="fixed" class="float-banner">
            <bolt-button slot="cancel" (click)="onCancel()" id="oysTrackerShopSelect_cancelBtn">Cancel</bolt-button>
            <bolt-button
                slot="forward"
                arialabel="continue"
                type="solid"
                (click)="continue()"
                id="oysTrackerShopSelect_continueBtn">
                Continue
            </bolt-button>
        </bolt-button-bar>
    }
</main>
